module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1001-ea1e12082979269b11b71cf80bd4fb1a.png";